import { CheckCircle2 } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem3D } from "@/components/anim/Reveal";
import Tilt3D from "@/components/anim/Tilt3D";
import { HE } from "@/lib/i18n";
import { t } from "@/lib/strings";

const INCLUDED_EN = [
  "Your 0–100 AI visibility score, broken down by platform",
  "Who AI recommends instead of you — competitor benchmark",
  "Your biggest weaknesses, ranked by impact",
  "Step-by-step fixes to become the business AI recommends",
];

const INCLUDED_HE = [
  "ציון נראות AI מ-0 עד 100, מפורק לפי פלטפורמה",
  "על מי ה-AI ממליץ במקומכם — השוואה מול המתחרים",
  "החולשות הכי גדולות שלכם, מדורגות לפי נזק",
  "תיקונים צעד-אחר-צעד — איך הופכים לעסק שה-AI ממליץ עליו",
];

const INCLUDED = HE ? INCLUDED_HE : INCLUDED_EN;

export const FullReportIncludes = ({ onCta }) => (
  <section className="py-20 md:py-28 border-b-2 border-obsidian">
    <div className="av-container grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <Reveal>
        <div className="flex items-center gap-3 mb-6">
          <div className="h-3 w-3 bg-conversion" />
          <span className="av-label text-obsidian">{HE ? "מה בתוך הדוח המלא" : "Inside the full report"}</span>
        </div>
        <h2 className="font-display text-3xl sm:text-4xl text-obsidian">
          {HE
            ? "כל מה שצריך כדי לנצח בחיפוש ה-AI — ישר לוואטסאפ."
            : "Everything you need to win AI search — delivered to WhatsApp."}
        </h2>
        <p className="mt-5 text-lg text-neutral-700 leading-relaxed">
          {HE ? (
            <>הבדיקה החינמית מראה את הציון. הדוח המלא מראה בדיוק איך לתקן — מותאם אישית לאתר שלכם, כולל <span dir="ltr">PDF</span> להורדה.</>
          ) : (
            <>The free test shows your score. The full report shows exactly how to fix it —
            personalized to your domain, with a downloadable PDF.</>
          )}
        </p>
        <button onClick={onCta} className="av-btn mt-8" data-testid="included-cta">{t("included.cta")}</button>
      </Reveal>

      <StaggerGroup className="grid grid-cols-1 sm:grid-cols-2 gap-3" gap={0.07}>
        {INCLUDED.map((item) => (
          <StaggerItem3D key={item}>
            <Tilt3D max={12} className="h-full">
              <div className="av-card av-card-hover p-4 flex items-start gap-3 h-full">
                <CheckCircle2 className="h-5 w-5 text-data-positive shrink-0 mt-0.5" />
                <span className="text-sm text-obsidian leading-snug">{item}</span>
              </div>
            </Tilt3D>
          </StaggerItem3D>
        ))}
      </StaggerGroup>
    </div>
  </section>
);

export default FullReportIncludes;
